import { render, staticRenderFns } from "./NavBlocks.vue?vue&type=template&id=51365502&lang=pug"
import script from "./NavBlocks.vue?vue&type=script&lang=js"
export * from "./NavBlocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports